import Vue from 'vue';
import common from './common';

// Add plugins
new Vue({
  ...common,

  data() {
    return {
      rootState: {}
    };
  },

  methods: {
    setRootData(key, value) {
      this.$set(this.rootState, key, value);
    }
  }
}).$mount('#main-container');
